class TaskCategoryFeaturedBlockPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_category_featured_block.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_category_featured_block._m';

    // Access scope - ALL: Can access all featured blocks
    static ACCESS_SCOPE_ALL = 'task_category_featured_block.access.scope.all';

    // Access scope - WORKSPACE: Can access only blocks, belonging to same workspace
    static ACCESS_SCOPE_WORKSPACE = 'task_category_featured_block.access.scope.workspace';

    // Can access archive
    static ACCESS_ARCHIVE = 'task_category_featured_block.access.archive';

    // Can access disabled blocks
    static ACCESS_DISABLED = 'task_category_featured_block.access.disabled';

    // Can create new block
    static CREATE = 'task_category_featured_block.create';

    // Can update block
    static UPDATE = 'task_category_featured_block.update';

    // Can archive block
    static ARCHIVE = 'task_category_featured_block.archive';

    // Can restore archived block
    static RESTORE = 'task_category_featured_block.restore';
}

export default TaskCategoryFeaturedBlockPermission;
